import DialogSnowboardType from "./DialogSnowboardType";
import model              from "./model";

export default {
    name     : 'dialog_snowboard_type',
    component: DialogSnowboardType,
    dialog   : {
        'max-width': "700px",
        'persistent': true
    },
    on       : {
        save(store, model) {
            store.commit('snowboard_type_save', model);
        }
    },
    model
}
